import React from 'react';
import { formatValue } from '../../utils/formatters';

const PerformanceMetricsSection = ({ 
    performanceMetrics,
    previewCoreWebVitals,
    defaultMetricsDisplay,
    hasAdditionalMetrics,
    metricsList,
    defaultMetrics,
    onViewDetails
}) => {
    if (!performanceMetrics) {
        return null;
    }

    return (
        <div style={{ marginBottom: '30px' }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '15px'
            }}>
                <h4 style={{ color: '#e0e0e0', fontWeight: '600', margin: 0 }}>Performance Metrics</h4>
                <button
                    onClick={onViewDetails}
                    style={{
                        backgroundColor: '#3a3a3a',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '8px 14px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: '600'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#4a4a4a'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#3a3a3a'}
                >
                    View performance details
                </button>
            </div>
            {previewCoreWebVitals.length > 0 && (
                <div style={{
                    backgroundColor: '#2d2d2d',
                    border: '1px solid #404040',
                    borderRadius: '6px',
                    padding: '20px',
                    marginBottom: defaultMetricsDisplay.length > 0 ? '20px' : 0
                }}>
                    <div style={{
                        fontSize: '12px',
                        color: '#a0a0a0',
                        textTransform: 'uppercase',
                        marginBottom: '12px',
                        fontWeight: '600',
                        letterSpacing: '0.5px'
                    }}>
                        Core Web Vitals Snapshot
                    </div>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                        gap: '12px'
                    }}>
                        {previewCoreWebVitals.map((item) => (
                            <div
                                key={item.key}
                                style={{
                                    backgroundColor: '#262626',
                                    border: '1px solid #373737',
                                    borderRadius: '6px',
                                    padding: '12px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px'
                                }}
                            >
                                <div style={{
                                    fontSize: '11px',
                                    color: '#909090',
                                    textTransform: 'uppercase',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '2px'
                                }}>
                                    <span>{item.shortLabel}</span>
                                    <span style={{
                                        fontSize: '10px',
                                        textTransform: 'none',
                                        fontWeight: '500',
                                        color: '#b8b8b8'
                                    }}>
                                        {item.label}
                                    </span>
                                </div>
                                <div style={{
                                    fontSize: '18px',
                                    color: '#e0e0e0',
                                    fontWeight: '600'
                                }}>
                                    {item.displayValue}
                                </div>
                                <div style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    alignSelf: 'flex-start',
                                    padding: '4px 10px',
                                    borderRadius: '12px',
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px',
                                    backgroundColor: item.statusColor,
                                    color: item.statusTextColor
                                }}>
                                    {item.statusLabel}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {defaultMetricsDisplay.length > 0 && (
                <div style={{
                    backgroundColor: '#2d2d2d',
                    border: '1px solid #404040',
                    borderRadius: '6px',
                    padding: '20px'
                }}>
                    <div style={{
                        fontSize: '12px',
                        color: '#a0a0a0',
                        textTransform: 'uppercase',
                        marginBottom: '12px',
                        fontWeight: '600',
                        letterSpacing: '0.5px'
                    }}>
                        Metrics Snapshot
                    </div>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                        gap: '12px'
                    }}>
                        {defaultMetricsDisplay.map(({ name, value, displayValue }) => (
                            <div key={name} style={{
                                backgroundColor: '#262626',
                                border: '1px solid #373737',
                                borderRadius: '6px',
                                padding: '12px'
                            }}>
                                <div style={{
                                    fontSize: '11px',
                                    color: '#909090',
                                    textTransform: 'uppercase',
                                    marginBottom: '6px',
                                    fontWeight: '600',
                                    letterSpacing: '0.5px'
                                }}>
                                    {name.replace(/([a-z])([A-Z])/g, '$1 $2')}
                                </div>
                                <div style={{
                                    fontSize: '18px',
                                    color: '#e0e0e0',
                                    fontWeight: '600'
                                }}>
                                    {displayValue ?? formatValue(value)}
                                </div>
                            </div>
                        ))}
                    </div>
                    {hasAdditionalMetrics && (
                        <div style={{
                            marginTop: '12px',
                            fontSize: '12px',
                            color: '#9a9a9a'
                        }}>
                            + {metricsList.length - defaultMetrics.length} more metrics in details
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default PerformanceMetricsSection;






